import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate, Button } from '@haldor/ui';
import { connect } from 'react-redux';
import '../_onboarding.scss';
import getEnvironment from 'lib/env';

var EmailAdminSent = /*#__PURE__*/function (_Component) {
  _inherits(EmailAdminSent, _Component);

  var _super = _createSuper(EmailAdminSent);

  function EmailAdminSent(props) {
    var _this;

    _classCallCheck(this, EmailAdminSent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(0).then(function () {
            resolve(1);
          });
        }
      });
    });

    _this.state = {
      sentEmailInfo: []
    };
    return _this;
  }

  _createClass(EmailAdminSent, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var product = getEnvironment().id;
      var productName = 'Haldor Education';

      if (product === 'haldor_planning') {
        productName = "Haldor Planning";
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        style: {
          textAlign: 'left'
        }
      }, this.props.translate('Email sent successfully!')), /*#__PURE__*/React.createElement("p", null, " ", this.props.translate('The e-mail was sent to:'), " ", this.props.emailSentList.join(", "), " "), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1rem',
          marginBottom: '5%'
        }
      }, this.props.translate('You can now continue using our services as usual. Once your admin approves, we\'ll notify you via email, and the new functionality will be accessible for you immediately.')), /*#__PURE__*/React.createElement("div", {
        style: {
          width: '20rem',
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/svg/illustration_steg06.svg"
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick() {
          _this2.props.showPage('showEmailInfo');
        }
      }, this.props.translate('Send again')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          _this2.props.showPage('navigateToAdminConsent');
        }
      }, this.props.translate('I am an Office 365-admin'), " ")));
    }
  }]);

  return EmailAdminSent;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    emailSentList: state.Services.emailSentList
  };
}

export default connect(mapStateToProps, {})(EmailAdminSent);